// components/Header.tsx
import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";

const Header: React.FC = () => {
  return (
    <Box
      sx={{ bgcolor: "#614438", color: "white", py: 3, px: 4, height: "150px" }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Muzukuru Funeral Services
          </Typography>
          <Typography variant="body2" color="rgba(255,255,255,0.8)">
            We provide compassionate funeral services that celebrate life and
            bring comfort to families during their most difficult moments. Our
            experienced team is here to guide you through every step with care
            and respect.
          </Typography>
        </Box>
        <Stack spacing={0.5} alignItems="flex-end">
          <Stack direction="row" spacing={1} alignItems="center">
            <PhoneIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2">+263 77 145 3985</Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <EmailIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2">admin@muzkuru.com</Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <LanguageIcon sx={{ fontSize: 16 }} />
            <Typography variant="body2">https://muzukuru.com/</Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Header;
